export default function ActiveButtonIcon() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 25 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.08594 6H21.0859M7.08594 12H17.0859M10.0859 18H14.0859" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

    )
}